import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { forkJoin, Observable, map } from "rxjs";
import { AppSettingsService } from "../common/appsettings.service";

export class CustomTranslateLoader implements TranslateLoader{
    
    constructor(private http:HttpClient, private appSettings: AppSettingsService){}
    
    getTranslation(lang: string): Observable<any> {

        if(!this.appSettings.settings.adminMenu){
            return this.http.get(`assets/language/user/${lang}.json`);
        }
        
        const user$ = this.http.get('assets/language/user/en.json');
        const admin$ = this.http.get('assets/language/admin/en.json');

        return forkJoin([user$,admin$]).pipe(
            map(([userJSON, adminJSON]) => {
                return {...userJSON, ...adminJSON}
            })
        );
    }
}